import { StockTransferItemDto } from "./stock-transfer-items-dto";

export class StockTransferDto{
    id:number;
challanType:string;
itemType:string
challanNo:string;
challandate:any;
poNo:string;
billFrom:string;
purpose:string;
addressCode:string;
addressDetails:string;
receipent:string;
employee:number;
refOrder:string;
value:string;
lr:string;
weight:string;
rolls:string;
status:string;
eWayBill:string;
fromLocation:number;
fromRack:number;
toLocation:number;
remarks:string;
  isActive:boolean;
  createdAt: Date;
createdUser: string | null;
updatedAt: Date;
updatedUser: string | null
versionFlag: number;
itemsInfo:StockTransferItemDto[]
}